<div class="w-full p-3 m-auto">
  <div
    thehubzFileDragNDrop
    (fileDropped)="fileHandler($event)"
    (dragover)="onDragOver()"
    (dragleave)="onDragOut()"
    (drop)="onDragOut()"
    [ngClass]="{ 'border-[#f44336]': required }"
    class="relative border-dotted h-32 rounded-lg border-2 border-black bg-gray-50 flex justify-center items-center"
    [attr.data-test-id]="'sp-file-drag-n-drop_area'"
  >
    <div class="absolute">
      <div class="flex flex-col items-center">
        <div class="w-[70%] text-5xl text-center">
          <mat-icon [inline]="true" class="material-icons-outlined">cloud_upload</mat-icon>
        </div>
        <div class="w-full block text-gray-700 font-normal">
          <ng-container *ngIf="uploadCaption; else otherElement">
            {{ uploadCaption }}
          </ng-container>
          <ng-template #otherElement i18n> "Browse or Drag 'n' Drop" </ng-template>
        </div>
      </div>
    </div>
    <input #fileDropRef id="fileDropRef" type="file" class="h-full w-full opacity-0" name="" [multiple]="multipleFile" (change)="fileHandler($event)" />
  </div>
</div>
